import { CircularProgress, IconButton, Omit } from '@material-ui/core'
import { ReplayRounded } from '@material-ui/icons'
import {
  AutocompleteProps as MuiAutocompleteProps,
  default as MuiAutocomplete,
} from '@material-ui/lab/Autocomplete'

import InputText from '@/components/input-text'

import { useStyles } from './styles'

interface AutocompleteProps<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
> extends Omit<
    MuiAutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
    'renderInput'
  > {
  optionsError?: boolean
  onRetry?: () => void
  inputTextProps?: React.ComponentProps<typeof InputText>
}

export const Autocomplete = <
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
>({
  optionsError,
  onRetry,
  inputTextProps,
  classes,
  ...rest
}: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) => {
  const innerClasses = useStyles()

  return (
    <MuiAutocomplete
      classes={{
        noOptions: innerClasses.secondaryMainColor,
        loading: innerClasses.secondaryMainColor,
        inputRoot: innerClasses.inputRoot,
        ...classes,
      }}
      loadingText='Carregando...'
      noOptionsText='Não encontrado'
      {...rest}
      renderInput={(params) => (
        <InputText
          {...params}
          {...inputTextProps}
          InputProps={{
            ...params.InputProps,
            ...inputTextProps?.InputProps,
            endAdornment: (
              <>
                {rest.loading ? (
                  <CircularProgress color='inherit' size={18} />
                ) : (
                  optionsError &&
                  onRetry && (
                    <IconButton
                      size='small'
                      onClick={onRetry}
                      aria-label='Retry'
                    >
                      <ReplayRounded fontSize='small' />
                    </IconButton>
                  )
                )}
                {params.InputProps.endAdornment}
                {inputTextProps?.InputProps?.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}
